import { callApi } from './api';

import { User } from '@/types/user';

export const updateInvToken = async (user: User) => {
  const request = {
    email: user.email,
    role: user.role,
  };
  const { status, result } = await callApi<LineInviteToken>(
    'users/token',
    'POST',
    undefined,
    request,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

type LineInviteToken = {
  token: string;
  staffID?: number;
  guardianID?: number;
  createdAt: string;
  updatedAt: string;
};
